/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// export var Globals = {};

export var Status = {
  CONNECTED: 1,
  DISCONNECTED: 2,
}

export var Protocol = {
  PING: '2',
  USER_SETTINGS_POST: '59',
  USER_SETTINGS_RESPONCE: '60',
  LOGIN: '61',
  LOGOUT: '62',
  GAME_STATE: '63',
  BET_POST: '64',
  BET_INFO_RESPONCE: '65',
  BET_INFO_ALL: '66',
  HISTORY: '67',
  HISTORY_END: '68',
  GET_JACKPOT: '69',
  JACKPOT_INFO: '70',
  JACKPOT_WIN: '71',
  SUBSCRIBE: '72',
  ERROR: '90',
  SET_SEED: '101',
  FIRST_DEAL: '102',
  FIRST_DEAL_RESPONCE: '103',
  NEXT_STEP: '104',
  NEXT_STEP_RESPONCE: '105',
  RESET: '106',
  RESET_RESPONCE: '107',
  DOUBLE_UP: '108',
  DOUBLE_UP_RESPONCE: '109',
  TAKE: '110',
  TAKE_RESPONCE: '111',
  DOUBLE_UP_ANSWER: '112',

  DOUBLE_UP_ANSWER_RESPONCE: '113',
  WIN_STATS: '114',
  WIN_STATS_RESPONCE: '115',
  GET_ROUND: '116',
  GET_ROUND_RESPONCE: '117',

  GET_SEEDS: '118',
  GET_SEEDS_RESPONCE: '119',

  GET_STATS: '120',
  GET_STATS_RESPONCE: '121',

  GET_FREE_BTC: '122',
  GET_FREE_BTC_RESPONCE: '123',

  START_ROUND: '124',
  STEP_ROUND: '125',
  END_ROUND: '126',
  STATE_ROUND: '127',

  ROUND_STATE: '131',
  ROUND_UPDATE: '132',
  ROUND_USER_UPDATE: '133',
  PLACE_BET: '134',
  CANCEL_BET: '135',
  PLACE_BET_RESPONCE: '136',
  CASHOUT: '137',
  CASHOUT_RESPONCE: '138',
  UPDATE_BALANCE_RESPONCE: '139',
  AIRDROP: '140',
  FULLROUND: '141',
  FULLROUNDRESPONCE: '142',

  END_MESSAGE: '\r\n',
  DELIMETER: ',',

}

export var ListType = {
  ALL: 'ALL',
  MY: 'MY',
  HIGH: 'HIGH',
}

export var EventType = {
  ALL: 'ALL',
  BUTTON_CLICKED: 'BUTTON_CLICKED',
  DU_BUTTON_CLICKED: 'DU_BUTTON_CLICKED',
}

export var ErrorTypes = {
  GENERAL_ERROR: '100',
  INVALID_MESSAGE: '101',
  INVALID_SERVICE: '102',
  CONCURRENT_CONNECTION: '103',
  ALREADY_LOGGED_IN: '104',
  NOT_LOGGED_IN: '105',
  SESSION_CLOSED: '105',
  INVALID_TRANSFER: '106',
  INVALID_BET_AMOUNT: '107',
  INSUFFICIENT_FUNDS: '108',
  INVALID_BET: '109',
  INVALID_SESSION: '110',
  RETRY: '111',
  STAGE_TIMEOUT: '112',
  MAX_BET_LIMIT: '115',
  // CLIENT_SEED_ERROR: '8',
  // INVALID_BET_AMOUNT: '4',
  // PF_NOT_SET: '7',
  // CLIENT_SEED_OK: '9',
  // SYSTEM_ERROR: '10',
  // INVALID_ACTION: '11',
  // SEAT_TAKEN: '12',
  // NOT_FOUND: '13',
  // GAME_NOT_ACTIVE: '14',
  // JACKPOT_NOT_ACTIVE: '15',
  // FAUCET_ERROR: '16',
  // INSUFFICIENT_RAISE_FUNDS: '17',
}

export const ErrorTexts = {
  CONCURRENT_CONNECTION: 'Another login has been detected',
  INVALID_SESSION: 'Something went wrong, please reload the page',
  INSUFFICIENT_FUNDS: 'Not enough balance',
  INVALID_BET_AMOUNT: 'Invalid stake amount',
  MONEY_TRANSFER_ERROR: 'Something went wrong, please reload the page',
  INVALID_BET: 'Invalid bet',
  PF_NOT_SET: 'Error saving seeds, please try again later',
  CLIENT_SEED_ERROR:
    'Length of the seed must be minimum 16  and maximum 128 symbols',
  CLIENT_SEED_OK: '9',
  SYSTEM_ERROR: 'Something went wrong, please reload the page',
  INVALID_ACTION: 'Invalid action',
  SEAT_TAKEN: '12',
  NOT_FOUND: 'Bet info is not found',
  GAME_NOT_ACTIVE: 'Game is not active',
  JACKPOT_NOT_ACTIVE: '15',
  CONNECTION_LOST: 'Your session has expired, please reload the page',
  FAUCET_ERROR:
    'Error claiming faucet. You can claim your faucet no more than 5 times during the course of 24 hours and your total currency balance must be less then 10 Satoshi. Please try again later',
}

export const Notifications = {
  minStake: 'Minimum stake limit is ', // {minimum_stake} {currency}
  maxStake: 'Maximum stake limit is ', // {maximum_stake} {currency}
  notEnoughBalance: 'Not enough balance',
  invalidAction: 'Invalid action',
  invalidBet: 'Invalid bet',
  copied: 'Copied to clipboard',
  notFound: 'Bet info is not found',
  onlyYourBet: 'You can only see your bet reply',
  cantChangeSeed: "You can't change the seed while round is active",
  cantSelectBeforeBet: "You can't make a selection before placing a bet",
  invalidSeed: 'Length of the seed must be minimum 16 and maximum 128 symbols',
  reachedMaxStake: "You've reached maximum stake - ", // {maximum_bet} {currency}
  stoppedOnLoss: 'Stopped on loss ', // {autorollLogic_ggr} {currency}
  stoppedOnWin: 'Stopped on win ', // {autorollLogic_ggr} {currency}
  onSelectedNumberOfBets: 'Stopped on a selected number of bets',
  moneyTransferError: 'Something went wrong, please reload the page',
  insufficientRaiseFunds: 'Not enough balance to make a Raise bet',
  stageTimeout: 'Stage Timeout',
  tryingtoreconnect: 'trying to reconnect',
  maxbetlimit: 'You have exceeded your betting limit'
}

export var WinTypes = [
  { coef: 0, name: '' },
  { coef: 0, name: 'JACKS OR BETTER' },
  { coef: 0, name: 'TWO PAIR' },
  { coef: 0, name: '3 OF A KIND' },
  { coef: 0, name: 'STRAIGHT' },
  { coef: 0, name: 'FLUSH' },
  { coef: 0, name: 'FULL HOUSE' },
  { coef: 0, name: '4 OF A KIND' },
  { coef: 0, name: 'STRAIGHT FLUSH' },
  { coef: 0, name: 'ROYAL FLUSH' },
]
